import BaseApi from './BaseApi'

export default {
  async search(params) {
    return await BaseApi.get('/user/site-work-items/search', { params })
  }
}
